module.exports = __webpack_public_path__ + "img/4HM.3a89c034.png";